<template>

  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Roster Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Roster Management</span></h4>
    </div>

    <div class="mt-4 roster-wrapper">
    <b-tabs pills v-model="rosterTabIndex" content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
      <b-tab lazy title="Attendance Management" v-if="$acl['roster/data'] == 2">
        <div class="">
          <roster-calendar :roster="roster == 1" :regularization="regularization"></roster-calendar>
        </div>
      </b-tab>

      <b-tab lazy title="Off Day Management" v-if="$acl['roster/offday'] == 2 && roster == 1">
        <roster-off-day-management></roster-off-day-management>
      </b-tab>

      <b-tab lazy title="Manual Assignment" v-if="$acl['roster/assign'] == 2">
        <roster-assignment :roster_assignment_enabled="roster_assignment_enabled" :roster="roster == 1"></roster-assignment>
      </b-tab>

      <b-tab lazy title="Swap Requests" v-if="$acl['roster/swaps'] == 2 && roster == 1">
        <roster-roster-swaps></roster-roster-swaps>
      </b-tab>

      <b-tab lazy title="Leaves" v-if="$acl['roster/leaves'] == 2">
        <roster-roster-leaves :roster="roster == 1"></roster-roster-leaves>
      </b-tab>

      <b-tab lazy title="Penalty" v-if="$acl['roster/penalty'] == 2 && penalty == 1">
        <div class="">
          <roster-penalty-runs></roster-penalty-runs>
        </div>
      </b-tab>
      <b-tab lazy title="Overtime" v-if="$acl['roster/overtime'] == 2 && overtime == 1">
        <div class="">
          <roster-overtime-runs></roster-overtime-runs>
        </div>
      </b-tab>

      <b-tab lazy title="Employee Geo Locations"  v-if="$acl['geolocation/mapemployee/all'] == 2">
        <div class="">
          <employee-geo-ocations ></employee-geo-ocations>
        </div>
      </b-tab>

      <b-tab lazy title="Employee Device Data" v-if="$acl['roster/device/employee'] == 2">
        <div class="">
          <roster-device-signup  @childToParent="goToData"></roster-device-signup>
        </div>
      </b-tab>

      <b-tab lazy title="Migrated Data" v-if="$acl['roster/leaves'] == 2" class="pt-3">
        <h4 class="mb-2 pb-2 border-bottom">Migrated Data</h4>
        <p style="font-size: 15px;" class="mb-4">Set leave and carry forward migration history for employees.</p>
        <div class="roster-page">
          <b-tabs v-model="migratedTabIndex" pills class="roster-tabs-pills" nav-class="roster-nav-pills" nav-wrapper-class="roster-nav-wrapper-pills" :nav-wrapper-style="{
              background: '#e2f9ff',
              borderRadius:'4px'
            }" :nav-style="{
              display: 'flex',
              margin: '0',
              borderRadius: '4px'
            }" >
            <b-tab lazy title-link-class="p-0">
              <template #title>
                <span :style="migratedTabStyle(0)" @mouseenter="migratedHoverTab = 0" @mouseleave="migratedHoverTab = null">
                  Leave Past Data
                </span>
              </template>

              <div>
                <roster-leaves-past-data></roster-leaves-past-data>
              </div>
            </b-tab>

            <b-tab lazy title-link-class="p-0">
              <template #title>
                <span :style="migratedTabStyle(1)" @mouseenter="migratedHoverTab = 1" @mouseleave="migratedHoverTab = null">
                  Carrying Data
                </span>
              </template>

              <div>
                <roster-carrying-data></roster-carrying-data>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-tab>

      
      <!-- <b-tab lazy title="Compensatory Leave" v-if="$acl['roster/compensatory-leave'] == 2">
        <div class="">
          <roster-compensatory-leaves-dashboard></roster-compensatory-leaves-dashboard>
        </div>
      </b-tab> -->

    </b-tabs>

  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      roster: 0,
      regularization: 0,
      penalty: 0,
      overtime: 0,
      rosterTabIndex: 0,
      migratedTabIndex: 0,
      migratedHoverTab: null,
      roster_assignment_enabled: false,
    }
  },
  methods: {
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/roster/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;
          this.regularization = response.data.regularization;
          this.penalty = response.data.penalty;
          this.overtime = response.data.overtime;
        }
      }.bind(this));
    },
    migratedTabStyle(index) {
      const active = this.migratedTabIndex === index;
      const hovered = this.migratedHoverTab === index;

      return {
        display: 'inline-block',
        padding: '10px 18px',
        color: active || hovered ? '#ffffff' : '#787878',
        background: active || hovered ? '#126D66' : 'transparent',
        border: 'none',
        borderRadius: '4px',
        boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
        cursor: 'pointer'
      };
    },
    getCount(){
      axios.get(this.$api_url + '/roster/employees/count').then(response => {
        this.roster_assignment_enabled = (response.data.roster > 0);
      })
    },
    goToData(i, msg=''){
      this.rosterTabIndex = i;
      if(msg) {
        this.$bvToast.toast(msg, {
          title: 'Success',
          variant: 'success',
          solid: true
        })
      }
    }
  },
  created() {
    this.getCount();
    this.getCompanyLeaveSettings();
  }
}
</script>
